export * from "./GlobalStyles";
export type Theme = typeof theme;

export const theme = {
  colors: {
    main: "rgb(147, 207, 129)",
    warn: "#fa990e",
    error: "rgb(255,97,120)",
    grey: "#303030",
    lightGrey: "#adadad"
  },

  avatarColors: {
    lightBlue: "rgb(139, 164, 210)",
    tirquoise: "#528575",
    purple: "rgb(126, 121, 204)",
    violet: "rgb(169, 123, 205)",
    thistle: "#E0BBE4",
    lavender: "#957DAD",
    pastelviolet: "#D291BC",
    cottoncandy: "#FEC8D8",
    sky: "#4b8eb3"
  }
};